<template>
  <div class="">
    <subscription-users/>
  </div>
</template>

<script>
import SubscriptionUsers from "@/plugin/components/dashboard/Subscription/SubscriptionUsers.vue";

export default {
  name: "Subscription",
  components: {SubscriptionUsers}
}
</script>

<style scoped>

</style>